@let ratingUnit = ratingUnitInput();
@let unitData = unitDataInput();
@let loop = loopInput();
@if (ratingUnit) {
  <div class="content">
    <div class="systemInputs">
      <div class="selectionFields inputPanel">
        <div class="inputButtonRow">
          <label class="inputLabel">Unit Type:</label>
          <select class="inputSelection" [(ngModel)]="ratingUnit.productId" (change)="productIdChanged()"
            [disabled]="isBusy()">
            <option [value]="''" [selected]="!ratingUnit.productId"></option>
            @for (productId of productIds(); track productId) {
              <option [value]="productId">{{ productId }}</option>
            }
          </select>
          <label class="inputLabel">Unit Tag:</label>
          <input class="tagInput" [(ngModel)]="unitData.userTag" [disabled]="isBusy()" (change)="emitChanges()"/>
        </div>
        @if (availableModels() && availableModels().length > 0) {
          <div class="inputRow">
            @if (availableModels() && availableModels().length > 0) {
              <span>
                <label class="inputLabel">Unit Style:</label>
                <select class="inputSelection" [(ngModel)]="ratingUnit.modelCode" (change)="selectedModelChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!ratingUnit.modelCode"></option>
                  @for (model of availableModels(); track model) {
                    <option [value]="model.modelCode">
                      {{ model.modelCode + ' - ' + model.description }}
                    </option>
                  }
                </select>
              </span>
            }
            @if (ratingUnit.modelCode && availableSizes() && availableSizes().length > 0) {
              <span>
                <label class="inputLabel">Size:</label>
                <select class="inputSelection" [(ngModel)]="ratingUnit.sizeCode" (change)="selectedSizeChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!ratingUnit.sizeCode"></option>
                  @for (size of availableSizes(); track size) {
                    <option [value]="size.sizeCode">{{ size.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
        @if (ratingUnit.modelCode) {
          <div class="inputRow">
            @if (ratingUnit.modelCode && systemTypes()?.length > 0) {
              <span>
                <label class="inputLabel">System Type:</label>
                <select class="inputSelection" [(ngModel)]="loop.systemTypeCode" [disabled]="true">
                  <option [value]="null" [selected]="!loop.systemTypeCode"></option>
                  @for (systemType of systemTypes(); track systemType) {
                    <option
                    [value]="systemType.code">{{ systemType.description }}</option>
                  }
                </select>
              </span>
            }
            @if (coilRows() && coilRows().length > 0) {
              <span>
                <label class="inputLabel">Coil Rows:</label>
                <select class="inputSelection" [(ngModel)]="ratingUnit.coilRowCode" (change)="coilRowsChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!ratingUnit.coilRowCode"></option>
                  @for (coilRow of coilRows(); track coilRow) {
                    <option [value]="coilRow.code">{{ coilRow.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
        @if (ratingUnit.modelCode) {
          <div class="inputRow">
            @if (availableMotorVoltages() && availableMotorVoltages().length > 0) {
              <span>
                <label class="inputLabel">Unit Power Supply:</label>
                <select class="inputSelection" [(ngModel)]="ratingUnit.powerSupplyCode"
                  (change)="selectedMotorVoltageChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!ratingUnit.powerSupplyCode"></option>
                  @for (voltage of availableMotorVoltages(); track voltage) {
                    <option
                    [value]="voltage.code">{{ voltage.description }}</option>
                  }
                </select>
              </span>
            }
            @if (availableMotorTypes() && availableMotorTypes().length > 0) {
              <span>
                <label class="inputLabel">Motor Type:</label>
                <select class="inputSelection" [(ngModel)]="ratingUnit.motorTypeCode" (change)="selectedMotorTypeChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!ratingUnit.motorTypeCode"></option>
                  @for (motorType of availableMotorTypes(); track motorType) {
                    <option
                    [value]="motorType.guruModelValue">{{ motorType.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
        @if (ratingUnit.modelCode) {
          <div class="inputRow">
            @if (availableFilters() && availableFilters().length > 0) {
              <span>
                <label class="inputLabel">Air Filter:</label>
                <select class="inputSelection" [(ngModel)]="ratingUnit.request.filter"
                  (change)="filterTypeChanged()" [disabled]="isBusy()">
                  <option [value]="null" [selected]="!ratingUnit.request.filter"></option>
                  @for (filter of availableFilters(); track filter) {
                    <option [value]="filter.code">{{ filter.description }}</option>
                  }
                </select>
              </span>
            }
            @if (availableElectricHeatKw() && availableElectricHeatKw().length > 0) {
              <span>
                <label class="inputLabel">Electric Heat KW:</label>
                <select class="inputSelection" [(ngModel)]="ratingUnit.electricHeatCode" (change)="electricHeatKwChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!ratingUnit.electricHeatCode"></option>
                  @for (kw of availableElectricHeatKw(); track kw) {
                    <option [value]="kw.code">{{ kw.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
      </div>
    </div>
    @if (ratingUnit.modelCode) {
      <div class="imageContainer">
        <img class="unitImage" [src]="getModelImageFileName()" alt=""/>
      </div>
    }
    @if (ratingUnit.modelCode && coilRows()?.length > 0 && ratingUnit.request) {
      <div class="performanceInput">
        <app-sure-flow-performance-input [request]="ratingUnit.request" [unitData]="unitData"
          (selectionChange)="performanceInputChanged()">
        </app-sure-flow-performance-input>
      </div>
    }
    @if (ratingUnit.modelCode && ratingUnit.response) {
      <div class="performanceOutput">
        <app-sure-flow-performance-output [response]="ratingUnit.response" [isMetric]="loop.metric">
        </app-sure-flow-performance-output>
      </div>
    }
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait</label>
    </div>
  </div>
}
